// extracted by mini-css-extract-plugin
export default {"modal":"ImportCandidatesModal-module__modal__+zdDM","content":"ImportCandidatesModal-module__content__oHgCV"};